import {
  Utensils,
  Coffee,
  Landmark,
  TreePine,
  Building2,
  ShoppingBag,
  MoreHorizontal,
} from "lucide-react";

export const spotCategories = [
  { id: "restaurant", labelKey: "categories.restaurant", icon: Utensils, color: "#ef4444" },
  { id: "cafe", labelKey: "categories.cafe", icon: Coffee, color: "#f97316" },
  { id: "landmark", labelKey: "categories.landmark", icon: Landmark, color: "#8b5cf6" },
  { id: "park", labelKey: "categories.park", icon: TreePine, color: "#22c55e" },
  { id: "museum", labelKey: "categories.museum", icon: Building2, color: "#3b82f6" },
  { id: "shop", labelKey: "categories.shop", icon: ShoppingBag, color: "#ec4899" },
  { id: "other", labelKey: "categories.other", icon: MoreHorizontal, color: "#6b7280" },
] as const;

export type SpotCategory = (typeof spotCategories)[number]["id"];

export const getCategoryById = (id: string) => {
  return spotCategories.find((cat) => cat.id === id) || spotCategories[spotCategories.length - 1];
};
